// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__BPMTv","fullWidth":"TextArea_fullWidth__133yy","isIOS":"TextArea_isIOS__SPFhm"};